import { LitElement, html, unsafeHTML, repeat } from './-global.min.js'

class WishlistPageList extends LitElement {
  PER_PAGE = 8

  static properties = {
    wishlistProducts: {
      state: true,
    },
    state: {
      state: true,
    },
    _currentPage: {
      state: true,
    },
    _paginated: {
      state: true,
    },
    shareEnabled: {
      type: Boolean,
      attribute: 'share-enabled',
    },
  }

  constructor() {
    super()

    this.wishlistProducts = []
    this.state = 'idle'
    this.$parentEl = this.closest('.main-wishlist')
    this._currentPage = 1
    this._paginated = {}
    this.shareEnabled = false
  }

  connectedCallback() {
    super.connectedCallback()

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(this.swymCallbackFn.bind(this))
  }

  updated(changedProperties) {
    if (changedProperties.has('wishlistProducts')) {
      this.handleWishlistProductsUpdate()
    }

    if (
      changedProperties.has('wishlistProducts') ||
      changedProperties.has('_currentPage')
    ) {
      this._setPaginated()
    }
  }

  swymCallbackFn(swat) {
    swat.fetchWrtEventTypeET((products) => {
      this.wishlistProducts = products
      this.state = 'loaded'

      this.$parentEl.classList.add('is-loaded')
    }, 4)
  }

  handleWishlistProductsUpdate() {
    if (this.wishlistProducts.length === 0 && this.state !== 'idle') {
      this.$parentEl.classList.add('is-empty')
    } else {
      this.$parentEl.classList.remove('is-empty')
    }
  }

  handleWishlistItemUpdate() {
    this.swymCallbackFn(window._swat)
  }

  _setPaginated() {
    const items = this.wishlistProducts
    const page = this._currentPage
    const perPage = this.PER_PAGE

    const totalPages = Math.ceil(items.length / perPage)
    const paginatedItems = items.slice(0, perPage * page)

    this._paginated = {
      previousPage: page - 1 ? page - 1 : null,
      nextPage: totalPages > page ? page + 1 : null,
      currentPage: page,
      total: items.length,
      totalPages: totalPages,
      items: paginatedItems,
    }
  }

  paginationSection() {
    const { total, totalPages, currentPage, items } = this._paginated
    const isLastPage = totalPages === currentPage
    const percent = items?.length / total || 0

    return html`<div class="main-wishlist__pagination-wrapper">
      <div class="main-wishlist__progress-wrapper">
        <p class="main-wishlist__progress-count caption" role="status">
          Showing ${items?.length} of ${total}
        </p>

        <div class="main-wishlist__progress-bar">
          <div
            class="main-wishlist__progress-indicator"
            style="--w: ${percent}"
          ></div>
        </div>
      </div>
      ${!isLastPage && total > 0
        ? html` <hh-button-wrapper theme="primary">
            <button
              type="button"
              class="main-wishlist__pagination-load-more-btn"
              @click="${() => this._currentPage++}"
              ?disabled="${totalPages === currentPage}"
            >
              Load more
            </button>
          </hh-button-wrapper>`
        : ''}
    </div>`
  }

  render() {
    if (!this.wishlistProducts) return
    const { items = [] } = this._paginated

    return html`
      <ul class="main-wishlist__product-list">
        ${repeat(
          items,
          (product) => product.epi,
          (product) => html`<li class="main-wishlist__product-list-item">
            <wishlist-page-item
              product-url="${product.du}"
              @wishlist-item:updated="${this.handleWishlistItemUpdate}"
            ></wishlist-page-item>
          </li>`
        )}
      </ul>
      ${items.length !== 0 && this.state === 'loaded'
        ? this.paginationSection()
        : ''}
      ${items.length !== 0 && this.shareEnabled && this.state === 'loaded'
        ? html`<wishlist-page-share></wishlist-page-share>`
        : ''}
    `
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('wishlist-page-list', WishlistPageList)

class WishlistPageItem extends LitElement {
  static properties = {
    productUrl: {
      attribute: 'product-url',
    },
    productCardHtml: {
      state: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.init()
  }

  async init() {
    if (!this.productUrl) return

    try {
      const res = await fetch(`${this.productUrl}?view=product-card`)
      this.productCardHtml = await res.text()
    } catch (error) {
      console.error(error)
    }
  }

  render() {
    return html`${unsafeHTML(this.productCardHtml)}`
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('wishlist-page-item', WishlistPageItem)

class WishlistSharedPageList extends LitElement {
  PER_PAGE = 8

  static properties = {
    wishlistProducts: {
      state: true,
    },
    wishlistDetails: {
      state: true,
    },
    state: {
      state: true,
    },
    _currentPage: {
      state: true,
    },
    _paginated: {
      state: true,
    },
  }

  constructor() {
    super()

    this.wishlistProducts = []
    this.state = 'idle'
    this.$parentEl = this.closest('.main-wishlist')
    this._currentPage = 1
    this._paginated = {}
  }

  connectedCallback() {
    super.connectedCallback()

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(this.swymCallbackFn.bind(this))
  }

  updated(changedProperties) {
    if (changedProperties.has('wishlistProducts')) {
      this.handleWishlistProductsUpdate()
    }

    if (
      changedProperties.has('wishlistProducts') ||
      changedProperties.has('_currentPage')
    ) {
      this._setPaginated()
    }
  }

  swymCallbackFn(swat) {
    const queryParams = swat.utils.getEncodedAsObject(window.location.search)
    const sharedHkey = queryParams['hkey'] || queryParams['lid']

    _swat.fetchListDetails(
      {
        lid: sharedHkey,
      },
      (listContents) => {
        const { list, items } = listContents

        this.wishlistProducts = items || []
        this.wishlistDetails = list || {}
        this.state = 'loaded'
      },

      (onError) => {
        console.error(onError)
      }
    )
  }

  handleWishlistProductsUpdate() {
    if (this.wishlistProducts.length === 0 && this.state !== 'idle') {
      this.$parentEl.classList.add('is-empty')
    } else {
      this.$parentEl.classList.remove('is-empty')
    }
  }

  _setPaginated() {
    const items = this.wishlistProducts
    const page = this._currentPage
    const perPage = this.PER_PAGE

    const totalPages = Math.ceil(items.length / perPage)
    const paginatedItems = items.slice(0, perPage * page)

    this._paginated = {
      previousPage: page - 1 ? page - 1 : null,
      nextPage: totalPages > page ? page + 1 : null,
      currentPage: page,
      total: items.length,
      totalPages: totalPages,
      items: paginatedItems,
    }
  }

  headerSection() {
    if (!this.wishlistDetails) return
    const {
      lname: listTitle = '',
      cnt: listCount = '',
      userinfo,
    } = this.wishlistDetails

    return html`
      <div class="main-wishtlist__header">
        <h1 class="h3 main-wishlist__title">${listTitle} (${listCount})</h1>

        <div>
          <p class="main-wishlist__content-message">
            You are viewing a read-only list shared by ${userinfo.fname}
            ${userinfo.lname}(${userinfo.em}).
            <a href="/account/login">
              To edit the list, log in with the email it was shared with.
            </a>
          </p>
        </div>
      </div>
    `
  }

  paginationSection() {
    const { total, totalPages, currentPage, items } = this._paginated
    const isLastPage = totalPages === currentPage
    const percent = items?.length / total

    return html`<div class="main-wishlist__pagination-wrapper">
      <div class="main-wishlist__progress-wrapper">
        <p class="main-wishlist__progress-count caption" role="status">
          Showing ${items?.length} of ${total}
        </p>

        <div class="main-wishlist__progress-bar">
          <div
            class="main-wishlist__progress-indicator"
            style="--w: ${percent}"
          ></div>
        </div>
      </div>
      ${!isLastPage
        ? html` <hh-button-wrapper theme="primary">
            <button
              type="button"
              class="main-wishlist__pagination-load-more-btn"
              @click="${() => this._currentPage++}"
              ?disabled="${totalPages === currentPage}"
            >
              Load more
            </button>
          </hh-button-wrapper>`
        : ''}
    </div>`
  }

  render() {
    if (!this.wishlistProducts) return
    const { items = [] } = this._paginated

    return html`
      ${this.headerSection()}
      <ul class="main-wishlist__product-list">
        ${repeat(
          items,
          (product) => product.epi,
          (product) => html`<li class="main-wishlist__product-list-item">
            <wishlist-page-item
              product-url="${product.du}"
              @wishlist-item:updated="${this.handleWishlistItemUpdate}"
            ></wishlist-page-item>
          </li>`
        )}
      </ul>
      ${items.length !== 0 && this.state === 'loaded'
        ? this.paginationSection()
        : ''}
    `
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('wishlist-shared-page-list', WishlistSharedPageList)
